import { NAME } from './constants'

export const FETCH = `${NAME}/FETCH`
export const CLEAR_FETCH = `${NAME}/CLEAR_FETCH`
export const ACTIVATE = `${NAME}/ACTIVATE`
export const EDIT = `${NAME}/EDIT`
export const ADD = `${NAME}/ADD`
export const DELETE = `${NAME}/DELETE`
